import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import IntegrationSteps from "./IntegrationSteps";
import Translate from "../../../../../../../../components/Translate";
import config from "../../../../../../../../config";
import CheckIcon from "../../../../../../../../assets/icons/CheckIcon";
import colors from "../../../../../../../../utils/Colors";
import CopyIcon from "../../../../../../../../assets/icons/CopyIcon";
import SilverButton from "../../../../../../../../components-new/buttons/SilverButton";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";

const styles = {
    header: {
        width: '70%',
        maxWidth: '1063px',
        margin: '0 auto',
        minWidth: 0,
        boxSizing: 'border-box'
    },
    copyField: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        background: 'var(--ds-bg-primary)',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        padding: '8px 12px',
    },
    copyFieldText: {
        display: 'block',
        flex: '1 1 auto',
        minWidth: 0,
        fontSize: '13px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};

class MobileIntegrationCode extends Component {
    constructor(props) {
        super(props);
        this.codeRef = React.createRef();
        this.state = {copied: false};
    }

    static getIntegrationCode(client) {
        const uri = encodeURI(`${config.WEBCHAT_HOST}/?version=${config.WEBCHAT_VERSION}&companyId=${client.id}&mobile=true`);
        return uri;
    }

    copyCodeToClipBoard = async (text) => {
        try {
            if (navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                this.codeRef.current.select();
                document.execCommand('copy');
            }

            this.setState({copied: true});
            setTimeout(() => this.setState({copied: false}), 1000);
        } catch (e) {
            this.setState({copied: false});
        }
    };

    render() {
        const {client} = this.props;
        const integrationCode = MobileIntegrationCode.getIntegrationCode(client);
        const {copied} = this.state;


        return (
            <div style={[styles.header]}>
                <div>
                    <IntegrationSteps>
                        <p style={{margin: 0}}><Translate text="mobileWebchatIntegrationText"/></p>
                        <p style={{margin: '10px 0 0', overflowWrap: 'anywhere'}}>
                            curl --location --request POST '{config.WEBBACK_HOST}/encrypt-username?username=testusername'
                        </p>
                    </IntegrationSteps>
                    <div style={styles.copyField}>
                        <Tooltip text={integrationCode} needTranslate={false}
                                 style={{minWidth: 0, flex: 1}}>
                            <span style={styles.copyFieldText}>{integrationCode}</span>
                        </Tooltip>
                        <SilverButton
                            onClick={() => this.copyCodeToClipBoard(integrationCode)}
                            variant={'ghost'}
                            styles={{
                                cursor: 'pointer',
                                marginLeft: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '24px',
                                height: '24px',
                                flexShrink: 0,
                                padding: '4px',
                                borderRadius: '4px'
                            }}
                        >
                            {copied
                                ? <CheckIcon width={16} height={16} style={{color: colors.success}}/>
                                : <CopyIcon width={16} height={16}/>
                            }
                        </SilverButton>
                    </div>
                    <textarea
                        style={{
                            position: 'fixed',
                            top: -10,
                            left: -10,
                            width: 1,
                            height: 1,
                            resize: 'none',
                            border: 'none',
                            padding: 0,
                        }}
                        ref={this.codeRef}
                        defaultValue={integrationCode}
                        readOnly
                    />
                </div>
            </div>
        );
    }
}

MobileIntegrationCode.propTypes = {
    client: PropTypes.object.isRequired,
    commonStyles: PropTypes.object.isRequired,
};

export default Radium(MobileIntegrationCode);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/components/MobileIntegrationCode.jsx